module.exports = __webpack_public_path__ + "static/media/UNI.6f7f0666.svg";